<template>
  <div class="ma-0 pa-0" style="height: 90vh; overflow: hidden">
    <Navigation />
    <v-row class="d-flex justify-end pa-0 ma-0">
      <v-col style="max-width: calc(100% - 56px)">
        <div class="pb-0 mb-0">
          <ToolbarTitles :title="title" class="d-flex flex-wrap mx-auto" />
        </div>
        <div
          class="d-flex flex-wrap justify-space-between my-auto pb-0 card_container mx-auto"
        >
          <data-employed />
          <nav-buttons :title="title" />
        </div>
        <OrganizationModel
          :headers="allHeaders"
          :deleteTitle="deleteTitle"
          :items="getTimePattern"
          :addTitle="addPatter"
          :saveConfigColums="saveConfigColumns"
          :asegurable="'accion:pautasempleado'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "./Navigation.vue";
import ToolbarTitles from "../../../Complement/ToolbarTitles.vue";
import OrganizationModel from "../../commons/OrganizationModel.vue";
import changeTimePattern from "@/store/gestionTiempos/changeTimePattern";
import NavButtons from "../../commons/NavButtons.vue";
import DataEmployed from "../../commons/DataEmployed.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
export default {
  components: {
    DataEmployed,
    Navigation,
    ToolbarTitles,
    OrganizationModel,
    NavButtons,
  },
  data() {
    return {
      title: "Pautas",
      addPatter: " Pauta",
      deleteTitle: "¿Desea eliminar la Pauta?",
      headers: [
        {
          text: "Fecha Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Fecha Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Liq.Horas",
          value: "liqhs",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tarde",
          value: "late",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Ret. anticipado",
          value: "retAnt",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Liq.Parcial",
          value: "licPar",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Liq.Total",
          value: "licTot",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Caídas",
          value: "falls",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Hs. caidas tot.",
          value: "hCaiTol",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cs.Costo",
          value: "nameCost",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Autorizar liq.",
          value: "autorizLiq",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    changeTimePattern.dispatch("getTimePattern");
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    getTimePattern() {
      const items = changeTimePattern.state.timePattern.item || [];

      const parseDate = (str) => {
        if (!str || str.trim() === "") return 0;
        const [day, month, year] = str.split("-");
        return new Date(`${year}-${month}-${day}`).getTime();
      };

      return [...items].sort((a, b) => {
        return parseDate(b.from) - parseDate(a.from);
      });
    },
  },
  methods: {
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
  },
};
</script>
